import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, Grid, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {setActivePromotionsScreenAction, setPreloader} from "../../Redux/content-reducer";
import {useMediaQuery} from "react-responsive";

const useStyles = makeStyles(theme => ({
    switcherBtn: props => ({
        opacity: `1`,
        height: `34px`,
        width: `100%`,
        '& > .MuiTypography-root': {
            fontSize: props.isLaptop ? `14px` : `23px`,
            fontWeight: `900`,
            color: `#c9c9c9`,
        },
        '&.isActiveBtn': {
            backgroundColor: `#E5870E`,
            '& > .MuiTypography-root': {
                color: `#ffffff`
            }
        },
        '&:not(.isActiveBtn)': {
            '&:hover': {
                backgroundColor: `transparent`
            }
        }
    }),
}))



export const ScreenSwitcher = (props) => {

    const dispatch = useDispatch();
    const {contentData, dropdownsReducer} = useSelector(state => state);
    const isLaptop = useMediaQuery({query: '(max-width: 1536px)'});
    const stylesProperties = {
        isLaptop: isLaptop
    }
    const classes = useStyles(stylesProperties);

    //switchScreenControls comp
    const selectedOptionValue = localStorage.getItem('selectedOptionValue');
    const [isActivePromosScreenBtn, setActivePromosScreenBtn] = useState(false);
    useEffect(() => {
        setActivePromosScreenBtn(contentData.isActivePromosScreen);
    }, [contentData.isActivePromosScreen])

    const onClickPromoBtn = () => {
        dispatch(setPreloader(true));
        dispatch(setActivePromotionsScreenAction(true));
        const format = dropdownsReducer.format;
        const supplierName = null;
        const productCategoryName = null;
        // const supplierName = props.data.dropdownsReducer.supplierValues.promos;
        // const productCategoryName = props.data.dropdownsReducer.productCategoryValues.promos
        props.getDataForPromos(selectedOptionValue, format, supplierName, productCategoryName, ``);
    }

    const onClickRegularPricesBtn = () => {
        dispatch(setPreloader(true));
        dispatch(setActivePromotionsScreenAction(false));
        const format = dropdownsReducer.format;
        const supplierName = null;
        const productCategoryName = null;
        // const supplierName = props.data.dropdownsReducer.supplierValues.prices;
        // const productCategoryName = props.data.dropdownsReducer.productCategoryValues.prices
        props.getDataForRegPrices(selectedOptionValue, format, supplierName, productCategoryName, ``);
    }


    return(
        <Grid container>
            <Grid item xs={6}>
                <Button
                    className={`${classes.switcherBtn} ${!isActivePromosScreenBtn ? `isActiveBtn` : ''}`}
                    disabled={contentData.isPreloader}
                    onClick={onClickRegularPricesBtn}>
                    <Typography fontSize={`23px`} fontWeight={900}>
                        מחירים רגילים
                    </Typography>
                </Button>
            </Grid>
            <Grid item xs={6}>
                <Button
                    className={`${classes.switcherBtn} ${isActivePromosScreenBtn ? `isActiveBtn` : ''}`}
                    disabled={contentData.isPreloader}
                    onClick={onClickPromoBtn}>
                    <Typography fontSize={`23px`} fontWeight={900}>
                        מבצעים
                    </Typography>
                </Button>
            </Grid>
        </Grid>
    )
}